<span class="px-3 py-1.5 text-sm font-medium tracking-tight text-gray-800">{{ title() }}</span>
